import { Country } from '@resurs-internal/mui/assets/countries';

export type Validation = {
  maxLength?: number;
  minLength?: number;
  pattern?: string;
  required?: boolean;
  translationPrefix: string;
};
export enum ValidationError {
  EMPTY,
  INVALID_LENGTH,
  INVALID_FORMAT,
}
export type AvailableCountry = Country.NO | Country.SE | Country.DK;

export const AvailableCountries: AvailableCountry[] = [
  Country.NO,
  Country.SE,
  Country.DK,
];

export const CountryName: { [key in AvailableCountry]: string } = {
  [Country.DK]: 'Denmark',
  [Country.NO]: 'Norway',
  [Country.SE]: 'Sweden',
};

export enum DefaultLanguage {
  NO = 'nb-NO',
  SE = 'sv-SE',
  DK = 'da-DK',
}

export enum GTMStatus {
  APPROVED = 'Approved',
  MANUAL_INSPECTION = 'Manual Inspection',
  REJECTED = 'Rejected',
}
